<template>
    <form method="post" enctype="multipart/form-data">
        <label for="input-select-certification">Certification *</label>
        <select
            :class="v && isError(v.formation.certification) ? 'error' : null"
            v-model="state.formation.certification"
            id="input-select-certification"
        >
            <option
                v-for="certification in certifications"
                :value="certification"
                :key="certification"
            >{{ certification }}</option>
        </select>
        <ErrorMessage
            v-if="v && isError(v.formation.certification)"
            message="Ce champ est nécessaire"
        />

        <label for="input-select-school">École *</label>
        <select
            :class="v && isError(v.formation.school) ? 'error' : null"
            v-model="state.formation.school"
            id="input-select-school"
        >
            <option
                v-for="school in schools"
                :value="school.name"
                :key="school.id"
            >{{ school.name }}</option>
        </select>
        <ErrorMessage v-if="v && isError(v.formation.school)" message="Ce champ est nécessaire" />

        <InputFile
            :error="v && isError(v.formation.files)"
            labelText="Documents à nous transmettre : les certifications requises pour l'adhésion au SUP-H *"
            keyStore="formation"
        ></InputFile>
        <ErrorMessage
            v-if="v && isError(v.formation.files)"
            message="Veuillez téléversez au minimum un fichier"
        />
        <span>
            Veuillez nous transmettre ci-dessus une copie de vos certifications de praticiens en Hypnose,
            en PNL ou de votre DU d'Hypnose validés dans une école reconnue par le SUP-H
        </span>

        <div style="margin-top: 1rem" class="inputs-radio-degree">
            <label>Disposez-vous par ailleurs de diplomes de Santé ou de psychologue ou de psychothérapeute *</label>
            <div>
                <input
                    v-model="state.formation.gotDegrees"
                    type="radio"
                    id="no"
                    name="degree"
                    :value="false"
                />
                <label style="margin: 0; padding: 0 0.25rem;" for="no">NON</label>
                <input
                    v-model="state.formation.gotDegrees"
                    type="radio"
                    id="yes"
                    name="degree"
                    :value="true"
                />
                <label style="margin: 0; padding: 0 0.25rem;" for="yes">OUI</label>
            </div>

            <!-- <ErrorMessage
                v-if="v && isError(v.formation.gotDegrees)"
                message="Ce champ est nécessaire"
            />-->
        </div>

        <slot v-if="state.formation.gotDegrees">
            <label for="input-precision">Si oui: préciser (médecin, infirmier...)</label>
            <input v-model="state.formation.precision" type="text" id="input-precision" />
        </slot>
    </form>
</template>

<script>
import axios from "axios";
import { onMounted, ref } from "vue";
import { state } from "../../store";
import { isError } from '../../validation';
import ErrorMessage from '../errors/ErrorMessage.vue';
import InputFile from "../Inputs/InputFile.vue";

export default {
    name: "ThirdStep",
    components: { ErrorMessage, InputFile },
    props: {
        v: {
            type: Object
        }
    },
    setup() {
        const certifications = ref(["Praticien hypnose", "Maître praticien hypnose", "Praticien PNL", "DU d'hypnose"]);
        const schools = ref([]);

        onMounted(async () => {
            await axios.get(`${wpApiSettings.root}api/v1/schools`)
                .then(res => {
                    res.data.forEach(school => {
                        schools.value.push(school);
                    });
                })
                .catch(err => {
                    console.log({ err });
                })
        })

        const pickFile = (pickedFile) => {
            state.formation.files = pickedFile.target.files;
        }

        return { certifications, state, schools, pickFile, isError };
    }
}
</script>

<style lang='scss' scoped>
span {
    color: gray;
    font-size: 12px;
}
.inputs-radio-degree {
    > div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.5rem;

        label {
            margin: 0;
        }
    }
}
</style>
